import { FC } from "react";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { clsxMerge } from "shared/lib/helpers/styles";

export const Divider: FC<PropsWithClassNameI> = ({ className }) => {
  return (
    <hr
      className={clsxMerge("h-[2px] w-full rounded-md bg-[#E5E7FF]", className)}
    />
  );
};
